/**
 * Search as a route module (web plan W5.1): `/search` and, after the URL move,
 * `/{cc}/{lang}/search`, registered in src/routes.ts like the other catalog
 * pages.
 *
 * Always `noindex, follow`: the server loader reads the SEO server's answer
 * for the URL (status, redirect, the titled `noindex` head; @/seo/pageDocument),
 * the decision the root loader reads, so W1.3's status, redirect and
 * Cache-Control are unchanged and the route's `meta` is that head. The
 * results depend on the visitor's query and load in the browser, as before:
 * the server reads no results (nothing to preload, nothing cached per query).
 * In-app navigations ask no server (`clientLoader`); the page's own head
 * (`<PageHead/>`) is the head there.
 */
import type { LoaderFunctionArgs } from 'react-router';
import { PageRoute } from '@/components/seo/PageRoute';
import { RouteErrorBoundary } from '@/components/seo/RouteErrorBoundary';
import SearchPage from '@/pages/SearchPage';
import { loadPageDocument, pageClientLoader, pageHeaders, pageMeta } from '@/seo/pageDocument';

export function loader({ context }: LoaderFunctionArgs) {
  return loadPageDocument(context);
}

export function clientLoader() {
  return pageClientLoader();
}

/** The document uses the server loader's data; only in-app navigations run `clientLoader`. */
clientLoader.hydrate = false as const;

export const headers = pageHeaders;

export const meta = pageMeta;

export const ErrorBoundary = RouteErrorBoundary;

export default function SearchRoute() {
  return (
    <PageRoute catalogPath="/search">
      <SearchPage />
    </PageRoute>
  );
}
